import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { SimpleChartDataset } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import {
  CurrencyValue,
  Flex,
  BarChart,
  formatDatetime
} from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('365');

  const [data, error] = useApi({
    url: `/accounting/operation/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const theme = useTheme();

  const [datasets] = useMemo(() => {
    const datasets: SimpleChartDataset[] = [
      {
        xField: 'date',
        yField: 'amount',
        label: 'Expense',
        backgroundColor: theme.colors.chartLine
      }
    ];

    return [datasets];
  }, [theme.colors]);

  const valueFormatter = useMemo(() => {
    function formatValue(value: string) {
      return (
        <CurrencyValue
          value={Number(value)}
          options={{
            currency: 'USDS'
          }}
        />
      );
    }

    return formatValue;
  }, []);

  const subValueFormatter = useMemo(() => {
    function formatValue(value: string) {
      return formatDatetime(value, { format: 'yyyy MMM' });
    }
    return formatValue;
  }, []);

  const config: ChartConfig = useMemo(() => {
    return {
      options: {
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'month'
            }
          }
        }
      }
    };
  }, []);

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <BarChart
          key="accounting_expenses"
          data={data.data}
          datasets={datasets}
          valueFormatter={valueFormatter}
          timeFilter={timeFilter}
          config={config}
          subValueFormatter={subValueFormatter}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
